import { enumBoxShapes, NS_SVG } from "../constants";
import { SVG_AddArc } from "./SVG_AddArc";
import { SVG_GetUniqueID } from "./SVG_GetUniqueID";
import { SVG_AddPair } from "./SVG_AddPair";
import { SVG_AddArcVerbose } from "./SVG_AddArcVerbose";

export function SVG_CreateTriPath2(bounds, boxShape, triPosition) {
  var path = document.createElementNS(NS_SVG, "path");
  var idStr = SVG_GetUniqueID("path");
  path.setAttribute("id", idStr);
  var r = bounds;
  var p = "";

  if (triPosition === 0) {
    switch (boxShape) {
      case enumBoxShapes.rectangle:
        p = SVG_AddPair("M", r.fLeft, r.fTop);
        p += SVG_AddPair("L", r.fRight, r.fTop);
        p += SVG_AddPair("L", r.fRight, r.fBottom);
        p += SVG_AddPair("L", r.fLeft, r.fTop);
        p += "Z";
        break;
      case enumBoxShapes.snipCornerRectangle:
        p = SVG_AddPair("M", r.fLeft, r.fTop);
        p += SVG_AddPair("L", r.fRight - r.fCornerRadius, r.fTop);
        p += SVG_AddPair("L", r.fRight, r.fTop + r.fCornerRadius);
        p += SVG_AddPair("L", r.fRight, r.fBottom);
        p += SVG_AddPair("L", r.fLeft, r.fTop);
        p += "Z";
        break;
      case enumBoxShapes.roundRectangle:
      case enumBoxShapes.roundSnipCornerRectangle:
        p = SVG_AddPair("M", r.fLeft, r.fTop);
        p += SVG_AddPair("L", r.fRight - r.fCornerRadius, r.fTop);
        p += SVG_AddArc(r.fRight, r.fTop + r.fCornerRadius, r.fCornerRadius);
        p += SVG_AddPair("L", r.fRight, r.fBottom);
        p += SVG_AddPair("L", r.fLeft, r.fTop);
        p += "Z";
        break;
    }
  } else if (triPosition === 1) {
    switch (boxShape) {
      case enumBoxShapes.snipCornerRectangle: // intentional fallthrough here. snip corner is on the right.
      case enumBoxShapes.rectangle:
        p = SVG_AddPair("M", r.fRight, r.fTop);
        p += SVG_AddPair("L", r.fLeft, r.fTop);
        p += SVG_AddPair("L", r.fLeft, r.fBottom);
        p += SVG_AddPair("L", r.fRight, r.fTop);
        p += "Z";
        break;
      case enumBoxShapes.roundRectangle:
      case enumBoxShapes.roundSnipCornerRectangle:
        p = SVG_AddPair("M", r.fRight, r.fTop);
        p += SVG_AddPair("L", r.fLeft + r.fCornerRadius, r.fTop);
        p += SVG_AddArcVerbose(
          r.fCornerRadius,
          r.fCornerRadius,
          0,
          0,
          0,
          r.fLeft,
          r.fTop + r.fCornerRadius
        );
        p += SVG_AddPair("L", r.fLeft, r.fBottom);
        p += SVG_AddPair("L", r.fRight, r.fTop);
        p += "Z";
        break;
    }
  } else if (triPosition === 2) {
    p = SVG_AddPair("M", r.fLeft, (r.fTop + r.fBottom) / 2);
    p += SVG_AddPair("L", (r.fRight + r.fLeft) / 2, r.fTop);
    p += SVG_AddPair("L", (r.fRight + r.fLeft) / 2, r.fBottom);
    p += SVG_AddPair("L", r.fLeft, (r.fTop + r.fBottom) / 2);
    p += "Z";
  } else if (triPosition === 3) {
    p = SVG_AddPair("M", r.fLeft, r.fBottom);
    p += SVG_AddPair("L", (r.fLeft + r.fRight) / 2, r.fTop);
    p += SVG_AddPair("L", r.fRight, r.fBottom);
    p += SVG_AddPair("L", r.fLeft, r.fBottom);
    p += "Z";
  } else {
    switch (boxShape) {
      case enumBoxShapes.rectangle:
      case enumBoxShapes.roundSnipCornerRectangle:
      case enumBoxShapes.snipCornerRectangle:
        p = SVG_AddPair("M", r.fLeft, r.fTop);
        p += SVG_AddPair("L", r.fRight, r.fTop);
        p += SVG_AddPair("L", r.fLeft, r.fBottom);
        p += SVG_AddPair("L", r.fLeft, r.fTop);
        p += "Z";
        break;
      case enumBoxShapes.roundRectangle:
        p = SVG_AddPair("M", r.fLeft + r.fCornerRadius, r.fTop);
        p += SVG_AddPair("L", r.fRight, r.fTop);
        p += SVG_AddPair("L", r.fLeft, r.fBottom);
        p += SVG_AddPair("L", r.fLeft, r.fTop + r.fCornerRadius);
        p += SVG_AddArc(r.fLeft + r.fCornerRadius, r.fTop, r.fCornerRadius);
        p += "Z";
        break;
    }
  }

  path.setAttribute("d", p);

  return path;
}
